import React from "react";

function Header() {

    return (
        <div id='header'>
            <img src='static/images/edocs-banner.jpg' height={'200px'}/>
        </div>
    );
}

export default Header;
